
import { motion } from 'framer-motion';

export default function Problem() {
  return (
    <section className="py-24 px-6 bg-gray-900 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-red-500/5 rounded-full blur-[100px]"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-orange-500/5 rounded-full blur-[100px]"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-block px-4 py-2 bg-red-500/10 border border-red-500/20 rounded-full mb-6">
            <span className="text-sm font-semibold text-red-400">Die Herausforderung</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Kennst du diese Probleme?
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Als SuperOne-Partner stehst du vor vielen Herausforderungen im Alltag
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Problem Cards */}
          {[
            {
              icon: 'ri-time-line',
              title: 'Zeitaufwändige Lead-Suche',
              description: 'Stundenlange manuelle Recherche nach potenziellen Kunden ohne Garantie auf Erfolg',
              color: 'red'
            },
            {
              icon: 'ri-file-list-line',
              title: 'Unorganisierte Kontakte',
              description: 'Leads verstreut in Excel, Notizen und verschiedenen Apps – kein Überblick',
              color: 'orange'
            },
            {
              icon: 'ri-question-line',
              title: 'Fehlende Qualifizierung',
              description: 'Schwer einzuschätzen, welche Leads wirklich Potenzial haben',
              color: 'yellow'
            },
            {
              icon: 'ri-mail-close-line',
              title: 'Ineffiziente Kommunikation',
              description: 'Jede E-Mail manuell schreiben kostet wertvolle Zeit',
              color: 'red'
            },
            {
              icon: 'ri-bar-chart-line',
              title: 'Keine Erfolgsmessung',
              description: 'Welche Aktivitäten funktionieren? Keine Daten, keine Antworten',
              color: 'orange'
            },
            {
              icon: 'ri-tools-line',
              title: 'Zu viele Tools',
              description: 'Verschiedene Systeme für verschiedene Aufgaben – kompliziert und teuer',
              color: 'yellow'
            }
          ].map((problem, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-8 border border-gray-700"
            >
              <div className={`w-14 h-14 bg-${problem.color}-500/20 rounded-xl flex items-center justify-center mb-6`}>
                <i className={`${problem.icon} text-${problem.color}-400 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">{problem.title}</h3>
              <p className="text-gray-400 leading-relaxed">{problem.description}</p>
            </motion.div>
          ))}
        </div>

        {/* Solution Teaser */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-16 text-center"
        >
          <div className="inline-block px-6 py-3 bg-green-500/10 border border-green-500/20 rounded-full">
            <span className="text-lg font-semibold text-green-400">
              <i className="ri-lightbulb-line mr-2"></i>
              Die Lösung: Eine zentrale Plattform für alles
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
